import React from 'react';
import Random from './Random';
import CountryC from './CountryC';
import './search.css';
import Input from './Input';

function Home(){


   
    
    return(
        <>
        <div className='maindivinput'>

            <h1 style={{marginBottom: '8px'}}>Find a <span style={{color: '#2a6f76',
    fontSize: '39px'}}>R</span>ecipe</h1>
            
            <Input inputname='inputsearc' fontsearch='48px'/>
        </div>

          <div style={{marginBottom: '37px'}}>
              <h1 style={{textAlign:'center'}}>Random Meals</h1>
            <div className='divresult'>
              <Random />
              <Random />
              <Random />
              <Random />
              <Random />
              <Random />
            </div>
          </div>
            <CountryC/>
           
        </>
    )
}

export default Home;